import { render } from "./Breadcrumbs.vue?vue&type=template&id=5f88fb1d&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=5f88fb1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f88fb1d"

export default script